import { EMPTY } from '@shared/utils/strings';
export function optionalBooleanValueToString(value) {
    if (value === undefined || value === null) {
        return EMPTY;
    }
    return value ? 'Oui' : 'Non';
}
